import type { OrderDetailPerspectiveView } from '@/api/hooks/useOrderDetails'
import { FileTextOutlined, ProfileOutlined } from '@ant-design/icons'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { BillsOfLadingGrid } from './BillsOfLadingGrid'
import { OrderInfoCard } from './OrderInfoCard'
import { DropCard } from './PlannedOrderPanel'
import { SiteDropsGrid } from './SiteDropsGrid'

interface OrderDetailsContentProps {
  perspectiveView: OrderDetailPerspectiveView
}

export function OrderDetailsContent({
  perspectiveView,
}: OrderDetailsContentProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 0px',
        margin: '0 auto',
        width: '100%',
      }}
    >
      {/* Order Details and Planned Order section */}
      <Horizontal gap={16} alignItems='stretch' style={{ overflow: 'visible' }}>
        {/* Order Details column */}
        <Vertical
          gap={12}
          style={{ overflow: 'visible', maxWidth: 420, flexShrink: 0 }}
        >
          <Horizontal gap={6} alignItems='center'>
            <FileTextOutlined
              style={{ fontSize: 14, color: 'var(--gray-600)' }}
            />
            <Texto
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: 'var(--gray-600)',
              }}
            >
              Order Details
            </Texto>
          </Horizontal>
          <OrderInfoCard order={perspectiveView} />
        </Vertical>
        {/* Planned order drop cards */}
        {perspectiveView.drops.map((drop, index) => (
          <Vertical key={index} gap={12} style={{ flex: 1, minWidth: 350 }}>
            {index === 0 && (
              <Horizontal gap={6} alignItems='center'>
                <ProfileOutlined
                  style={{ fontSize: 14, color: 'var(--gray-600)' }}
                />
                <Texto
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: 'var(--gray-600)',
                  }}
                >
                  Planned Order
                </Texto>
              </Horizontal>
            )}
            {index !== 0 && <div style={{ height: 22 }} />}
            <DropCard drop={drop} units={perspectiveView.units} />
          </Vertical>
        ))}
      </Horizontal>

      {/* Bills of Lading section - always show */}
      <BillsOfLadingGrid
        bols={perspectiveView.bols}
        units={perspectiveView.units}
      />

      {/* Site Drops section - always show */}
      <SiteDropsGrid
        executedDrops={perspectiveView.executed_drops}
        units={perspectiveView.units}
      />
    </div>
  )
}
